export default __webpack_public_path__ + "static/media/idea-title-3.5467eaba.png";